import { useMemo } from 'react';
import type { WorkingHours } from '@elfsight/widget-business-hours';
import { Weekday } from '@elfsight/widget-business-hours';
import { useSettings } from '@wu/widget-core';

export type SettingsWeek = SettingsWeekDay[];

export type SettingsWeekDay = {
  weekday: Weekday;
  settingsHours: WorkingHours[];
  isClosed: boolean;
  weekdayIndex: number;
};

export function useSettingsWeek(): SettingsWeek {
  const {
    daySundayHours,
    daySundayOpen,
    dayMondayHours,
    dayMondayOpen,
    dayTuesdayHours,
    dayTuesdayOpen,
    dayWednesdayHours,
    dayWednesdayOpen,
    dayThursdayHours,
    dayThursdayOpen,
    dayFridayHours,
    dayFridayOpen,
    daySaturdayHours,
    daySaturdayOpen
  } = useSettings();

  return useMemo(
    () => [
      {
        weekday: Weekday.sunday,
        settingsHours: daySundayHours,
        isClosed: !daySundayOpen,
        weekdayIndex: 0
      },
      {
        weekday: Weekday.monday,
        settingsHours: dayMondayHours,
        isClosed: !dayMondayOpen,
        weekdayIndex: 1
      },
      {
        weekday: Weekday.tuesday,
        settingsHours: dayTuesdayHours,
        isClosed: !dayTuesdayOpen,
        weekdayIndex: 2
      },
      {
        weekday: Weekday.wednesday,
        settingsHours: dayWednesdayHours,
        isClosed: !dayWednesdayOpen,
        weekdayIndex: 3
      },
      {
        weekday: Weekday.thursday,
        settingsHours: dayThursdayHours,
        isClosed: !dayThursdayOpen,
        weekdayIndex: 4
      },
      {
        weekday: Weekday.friday,
        settingsHours: dayFridayHours,
        isClosed: !dayFridayOpen,
        weekdayIndex: 5
      },
      {
        weekday: Weekday.saturday,
        settingsHours: daySaturdayHours,
        isClosed: !daySaturdayOpen,
        weekdayIndex: 6
      }
    ],
    [
      daySundayHours,
      daySundayOpen,
      dayMondayHours,
      dayMondayOpen,
      dayTuesdayHours,
      dayTuesdayOpen,
      dayWednesdayHours,
      dayWednesdayOpen,
      dayThursdayHours,
      dayThursdayOpen,
      dayFridayHours,
      dayFridayOpen,
      daySaturdayHours,
      daySaturdayOpen
    ]
  );
}
